export const SYS_ADMIN = "System Admin";
// membership
export const MEMBERSHIP_ADMIN = "Membership Admin";
export const AFF_ADMIN = "Affiliates Admin";
export const LOCAL_USER = "Local User";
// political
export const POLITICAL_ADMIN = "Events Admin";
export const LOCAL_POLITICAL_USER = "Local Event User";

export const MEMBERSHIP_ROLES = [MEMBERSHIP_ADMIN, AFF_ADMIN, LOCAL_USER];
export const POLITICAL_ROLES = [POLITICAL_ADMIN, LOCAL_POLITICAL_USER];
